import { USER_PROFILE_UPDATE  } from '../actionTypes/actionTypes'

export function updateUserProfile(profileData) {
    return { type: USER_PROFILE_UPDATE, profileData }
}

